import React, { createContext, useContext } from 'react'

export interface LayoutContextValue {
  /** Sidebar expandida (true) ou colapsada (false). Quando colapsada, a área de conteúdo fica mais larga. */
  sidebarOpen: boolean
}

const LayoutContext = createContext<LayoutContextValue>({ sidebarOpen: true })

export const useLayout = () => useContext(LayoutContext)

export const LayoutProvider: React.FC<{ children: React.ReactNode; sidebarOpen: boolean }> = ({
  children,
  sidebarOpen,
}) => (
  <LayoutContext.Provider value={{ sidebarOpen }}>
    {children}
  </LayoutContext.Provider>
)
